module.exports = __webpack_public_path__ + "static/dunning-retention-e08f0942d938ba44f946a811281fa579.svg";